import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Accordion, Alert, Skeleton } from "@flat-ui";
import { SnapshotMemberList } from "@pages/project-details/project-snapshots/snapshot-member-list";
import { fetchingProjectsFlagsSelector, selectedSnapshotMembersSelector } from "@store/projects/projects-selector";
import { fetchSnapshotMembers } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useEffect } from "react";
import { sortSnapshotMembers } from "@pages/project-details/project-snapshots/snapshot-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { SnapshotEvents } from "@utils/track-event/track-event-list";
import { isUserSnapshotViewOnly } from "@utils/permission-control/snapshot-permission-control";
/** Renders the members of a snapshot in share dialog */
export function SnapshotMembers(t0) {
  const $ = _c(24);
  const {
    snapshot,
    location
  } = t0;
  const dispatch = useAppDispatch();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const members = useAppSelector(selectedSnapshotMembersSelector);
  const {
    isFetchingSnapshotMembers
  } = useAppSelector(fetchingProjectsFlagsSelector);
  let t1;
  if ($[0] !== members) {
    const membersWithoutOwner = members.filter(_temp);
    t1 = sortSnapshotMembers(membersWithoutOwner);
    $[0] = members;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortedMembers = t1;
  let t2;
  let t3;
  if ($[2] !== dispatch || $[3] !== handleErrorWithToast || $[4] !== snapshot) {
    t2 = () => {
      const fetchMembers = async function fetchMembers() {
        ;
        try {
          await dispatch(fetchSnapshotMembers({
            snapshotId: snapshot.id
          })).unwrap();
        } catch (t4) {
          const error = t4;
          handleErrorWithToast({
            id: `ProjectSnapshots-fetchMembers-${Date.now().toString()}`,
            title: "Could not fetch snapshot members",
            error
          });
        }
      };
      fetchMembers();
    };
    t3 = [dispatch, handleErrorWithToast, snapshot];
    $[2] = dispatch;
    $[3] = handleErrorWithToast;
    $[4] = snapshot;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  if (isFetchingSnapshotMembers === "pending") {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Skeleton variant="rectangular" height="48px" sx={{
        marginTop: SPACE_ELEMENTS_OF_MODAL
      }} />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (isFetchingSnapshotMembers === "rejected") {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Alert variant="warning" title="Snapshot members could not be fetched" sx={{
        marginTop: SPACE_ELEMENTS_OF_MODAL
      }} />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t4;
  if ($[9] !== location || $[10] !== snapshot) {
    t4 = location === "snapshot-sidepanel" || isUserSnapshotViewOnly(snapshot);
    $[9] = location;
    $[10] = snapshot;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = `${sortedMembers.length} people are invited`;
  let t6;
  if ($[12] !== location || $[13] !== trackEvent) {
    t6 = isExpanded => {
      trackEvent({
        name: SnapshotEvents.toggleSnapshotMembers,
        props: {
          isExpanded,
          location
        }
      });
    };
    $[12] = location;
    $[13] = trackEvent;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== location || $[16] !== snapshot || $[17] !== sortedMembers) {
    t7 = <SnapshotMemberList members={sortedMembers} snapshot={snapshot} location={location} />;
    $[15] = location;
    $[16] = snapshot;
    $[17] = sortedMembers;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <Accordion isDefaultExpanded={t4} title={t5} onChange={t6}>{t7}</Accordion>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
function _temp(member) {
  return member.role !== "RESOURCE_OWNER";
}